module.exports = __webpack_public_path__ + "img/pro_7.85f8aecc.png";